import { bool, string, func } from 'prop-types';

const CollapsibleCardPropTypes = {
  content: string.isRequired,
  isExpanded: bool.isRequired,
  title: string.isRequired,
  onClick: func.isRequired,
};

const CollapsibleCardHeaderPropTypes = {
  isExpanded: bool.isRequired,
  title: string.isRequired,
  onClick: func.isRequired,
};

const CollapsibleCardContentPropTypes = {
  content: string.isRequired,
  isExpanded: bool.isRequired,
};

export { CollapsibleCardPropTypes, CollapsibleCardHeaderPropTypes, CollapsibleCardContentPropTypes };
